import { Injectable } from '@angular/core';

import { IObjectCountSettings } from './interfaces';

@Injectable({
    providedIn: 'root'
})
export class ObjectCountWidgetService {
    areSettingsValid(settings: IObjectCountSettings): boolean {
        const localValid = !!(settings.local && settings.local.countType);
        const remoteValid = !!settings.remote;
        return localValid && remoteValid;
    }

    areRemoteSettingsEmpty(remoteSettings: any): boolean {
        return (!remoteSettings || Object.keys(remoteSettings).length === 0);
    }
}
